import { render, staticRenderFns } from "./LazadaConnectShippingFee.vue?vue&type=template&id=65c5ddc0&scoped=true&"
import script from "./LazadaConnectShippingFee.vue?vue&type=script&lang=js&"
export * from "./LazadaConnectShippingFee.vue?vue&type=script&lang=js&"
import style1 from "./LazadaConnectShippingFee.vue?vue&type=style&index=1&id=65c5ddc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c5ddc0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c5ddc0')) {
      api.createRecord('65c5ddc0', component.options)
    } else {
      api.reload('65c5ddc0', component.options)
    }
    module.hot.accept("./LazadaConnectShippingFee.vue?vue&type=template&id=65c5ddc0&scoped=true&", function () {
      api.rerender('65c5ddc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Connector/components/Lazada/LazadaConnectShippingFee.vue"
export default component.exports